/**
 *  Added Version popup
 *  Author: Teemo
 *  CreatedAt: 2021-03-10
 */

import React from 'react';
import AddVersion from '@/src/constrains/SingleAddModal/AddUnit';
import Row from '@/src/components/Layouts/Row/Row';

const AddVersionModal = (props) => {
  const { setShowModal, onSubmit, defaultValue, title, okText } = props;

  return (
    <Row
      elements={[
        {
          child: (
            <AddVersion
              defaultValue={defaultValue}
              maxLength={100}
              title={title}
              okText={okText}
              setModal={setShowModal}
              onSubmit={onSubmit}
            />
          ),
        },
      ]}
    />
  );
};

export default AddVersionModal;
